export default [
  {
    path: 'companies',
    name: 'companies',
    component: () => import('@/views/companies/Companies.vue'),
    meta: { registerNavFromMenu: true }
  },
  {
    path: 'companies/:id/details',
    name: 'companies/detail',
    component: () => import('@/views/companies/Company.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  },
  // {
  //   path: 'companies/:id/configtransf',
  //   name: 'companies/configtransf',
  //   component: () => import('@/views/companies/ConfigTransformador.vue'),
  //   meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  // },
  {
    path: 'companies/:id/config',
    name: 'companies/config',
    component: () => import('@/views/companies/Config.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  },
  {
    path: 'companies/:id/pgeconfig',
    name: 'companies/pgeconfig',
    component: () => import('@/views/companies/PGEConfig.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  },
  {
    path: 'companies/:id/apsconfig',
    name: 'companies/apsconfig',
    component: () => import('@/views/companies/APSConfig.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  },
  {
    path: 'companies/:id/tbaiconfig',
    name: 'companies/tbaiconfig',
    component: () => import('@/views/companies/TBAIConfig.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  },
  {
    path: 'companies/:id/historical',
    name: 'companies/historical',
    component: () => import('@/views/historical/CompanyHistorical.vue'),
    meta: { secondaryMenu: 'companies', registerNavFromMenu: false }
  }
]
